import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';

export const accordion: ThemeUICSSObject = {
  primary: {
    '&, .accordion__item': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    '.accordion__item__button__rightGroup': {
      flexShrink: 0,
    },
    '.accordion__item__button__leftGroup, .accordion__item__button__rightGroup':
      {
        alignItems: 'center',
        display: 'flex',
        gap: 3,

        '& > *': {
          flexShrink: 0,

          '&.accordion__item__button__label': {
            flexShrink: 1,
          },
        },
      },

    '.accordion__item__button__label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flexShrink: 1,
      color: 'palette.primary.contrastText',
      fontSize: 16,
    },

    '.accordion__item__button__check': {
      width: '32px',
      height: '32px',
      background: 'palette.background.paper',
      border: '1px solid',
      // borderColor: 'palette.border.field',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'stretch',
      p: 2,

      svg: {
        color: 'palette.text.primary',
        height: '100%',
        width: '100%',
      },
    },

    '.accordion__item:last-of-type > *': {
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.section',
    },

    '.accordion__item__content > *': {
      p: 4,
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderLeftColor: 'palette.border.section',
      borderRightColor: 'palette.border.section',
    },

    '.accordion__item__button': {
      width: '100%',
      p: 3,

      '.button__content': {
        alignItems: 'center',
        display: 'flex',
        gap: spacing(3),
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    '.accordion__cell__renderer': {
      display: 'flex',
    },
  },
  panels: {
    variant: 'layout.common.components.accordion.primary',
    overflowX: 'hidden',
    '.accordion__item__button': {
      color: 'palette.text.primary',
      pl: 4,
      background: 'palette.background.paper',
      border: 'none',
      borderTop: '1px solid',
      borderColor: 'palette.border.section',
      boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      ':hover': {
        background: 'palette.gray.900',
        borderColor: 'palette.border.section',
        color: 'palette.text.primary',
      },
      ':active': {
        background: 'palette.border.section',
      },
      svg: {
        path: {
          fill: 'palette.text.primary',
        },
      },
    },

    '.accordion__item__button__label': {
      color: 'palette.text.primary',
      fontWeight: '400',
    },
    '.accordion__item__content[aria-hidden="true"]': {
      border: 'none',
    },
    '.accordion__item__button__check': {
      borderColor: 'palette.border.section',
      borderRadius: '3px',
    },
    '.accordion__item__content': {
      background: 'palette.secondary.light',
      '[data-variant="link"]': {
        px: 0,
      },
      div: {
        border: 'none',
      },
    },
  },
};
